import { PolicyUsage } from "@covertree/new-business-graphql";
import { OwnershipType } from "@covertree/types";

export function getOwnershipTypeBasedOnPolicyUsage(
  policyUsage?: PolicyUsage
): OwnershipType | undefined {
  if (policyUsage === PolicyUsage.Rental) {
    return OwnershipType.Landlord;
  }

  if (policyUsage) {
    return OwnershipType.Resident;
  }

  return undefined;
}
